import i18n from 'src/i18n';

import type { ILabelResolver } from './types';

export class QuarterResolver implements ILabelResolver {
  tryGetLabelByKey(key: string): string | null {
    const quarterNumber = Number(key.split('Q').at(-1));

    if (Number.isNaN(quarterNumber)) {
      return null;
    }

    const year = key.slice(2, 4);

    return i18n.t('dashboard:Chart.quarterLabel', { number: quarterNumber, year });
  }
}
